import {
    autoUpdate,
    flip,
    offset,
    shift,
    useFloating,
} from "@floating-ui/react";
import {
    faChevronDown,
    faMapLocationDot,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "@headlessui/react";
import { GeoFilterArea } from "../../filters/GeoFilterSelect";

interface LocationPresetFilterWrapperProps {
    filterValue?: number[];
    setFilterValue: (value?: number[]) => void;
}

export const LocationPresetFilterWrapper = ({
    filterValue,
    setFilterValue,
}: LocationPresetFilterWrapperProps) => {
    const isDefault = !filterValue || filterValue.length === 0;

    const { refs, floatingStyles } = useFloating({
        strategy: "fixed",
        placement: "bottom-start",
        middleware: [offset({ mainAxis: 4 }), shift(), flip()],
        whileElementsMounted: autoUpdate,
    });

    const getDisplayText = () => {
        if (!filterValue || filterValue.length === 0) {
            return "All locations";
        }
        if (filterValue.length === 1) {
            return "1 location";
        }
        return `${filterValue.length} locations`;
    };

    const handleSelect = (selection: number[]) => {
        setFilterValue(selection.length > 0 ? selection : undefined);
    };

    return (
        <div ref={refs.setReference}>
            <Popover>
                {({ close }) => (
                    <>
                        <Popover.Button
                            className={`
                                flex items-center gap-2 px-3 h-8 text-sm border
                                rounded bg-white hover:bg-ae-gray-100
                                ${isDefault ? "border-ae-gray-250" : "border-ae-blue-550 bg-ae-blue-100"}
                            `}
                        >
                            <FontAwesomeIcon
                                icon={faMapLocationDot}
                                className="w-4 text-ae-blue-550"
                            />
                            <span className="text-neutral-600 hidden xl:block whitespace-nowrap">
                                {getDisplayText()}
                            </span>
                            <FontAwesomeIcon
                                icon={faChevronDown}
                                className="w-3"
                            />
                        </Popover.Button>
                        <Popover.Panel
                            ref={refs.setFloating}
                            style={floatingStyles}
                            onKeyUp={(key) => {
                                if (key.code === "Enter") {
                                    close();
                                }
                            }}
                            className="w-[480px] max-h-96 overflow-visible rounded-md bg-white border-2 border-ae-slate-300 z-50 drop-shadow-lg"
                        >
                            <GeoFilterArea
                                selectedPresets={filterValue || []}
                                setSelectedPresets={handleSelect}
                            />
                        </Popover.Panel>
                    </>
                )}
            </Popover>
        </div>
    );
};
